import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Цифра на вкладке таббара.
 *
 * Своя, а не вкуишный Counter: тот красится акцентом, а акцент у нас бирюза —
 * тот же цвет, которым подсвечена сама активная вкладка, и счётчик в ней
 * тонул. В макетах эта цифра единственная залитая малиновым во всём таббаре,
 * и смысл у неё ровно такой: «сюда ещё не смотрели».
 */
export function TabCount({ children }: { children: ReactNode }) {
  return <span className={styles.tabCountBadge}>{children}</span>;
}
